export enum ProductCategory {
  Sculptwear = 'Sculptwear',
  SoftSculpt = 'SoftSculpt',
  LiftWear = 'LiftWear',
  Underwear = 'Underwear',
  GiftCard = 'Gift Card',
  SwimWear = 'SwimWear',
  LifeWear = 'LifeWear',
  BoostWear = 'BoostWear',
  Miscellaneous = 'Miscellaneous',
  AddOns = 'AddOns',
  BodySculpt = 'BodySculpt',
}
